let routerNames = {
    route: {
        main: 'route',
    },
    dashboard: {
        main: 'Dashboard',
    },
    help: {
        main: 'Help',
    },
    app: {
        user: {
            edit: {
                main: 'App.user.edit'
            }
        }
    },
    users: {
        main: 'Users',
        actions: 'Users_actions',
        history: 'Users.history',
        edit: {
            main: 'Users.edit',
            password: 'Users.change-password',
            create: 'Users.create',
            setup_dns: 'Users.setup-dns',
            customize: 'Users.edit.customize',
            customizeBackground: 'Users.edit.customize.background',
            services: 'Users.edit.services',
            accessRights: 'Users.edit.accessRights',
        }
    },
    usersProfiles: {
        main: 'Profiles',
        actions: 'Profiles.actions',
        history: 'Profiles.history',
        edit: {
            main: 'Profiles.edit',
        }
    },
    orchestrator: {
        main: 'orchestrator',
    },
    md: {
        main: 'MD',
        fleet: {
            main: 'MD.fleet',
            widget: 'MD.fleet.widget',
        },
        vision: {
            main: 'MD.vision',
            video: 'MD.vision.video',
            cameras: {
                main: 'MD.vision.cameras',
                groupId: {
                    main: 'MD.vision.cameras.groupId',
                    video: 'MD.vision.cameras.groupId.video',
                }
            },
            driverScorecard: {
                main: 'MD.vision.driverScorecard'
            }
        },
        xcool: {
            main: 'MD.xcool',
            reefers: {
                main: 'MD.xcool.reefers'
            },
            greenSee: {
                main: 'MD.xcool.greenSee',
                date: 'MD.xcool.greenSee.date',
                tripId: 'MD.xcool.greenSee.tripId',
                track: 'MD.xcool.greenSee.track',
                graph: 'MD.xcool.greenSee.graph',
            },
            groupId: {
                main: 'MD.xcool.groupId',
            }
        },
        edgetensor: {
            main: 'MD.edgetensor',
        },
    },
    units: {
        main: 'Units',
        fastGeozone: {
            main: 'Units.fastGeozone',
            group: 'Units.fastGeozone.group',
        },
        id: 'Units.id',
        all: {
            main: 'Units.all',
            info: 'Units.all.info',
        },
        lite: 'Units.lightView',
        locator: 'Units.locator',
        chat: 'Units.chat',
        history: 'Units.history',
        commands: {
            main: 'Units.command',
            group: 'Units.groupCommand',
        },
        info: 'Units.info',
        edit: {
            main: 'Units.edit',
            group: 'Units.groupEdit',
            create: 'Units.create',
        },
        xroute: {
            main: 'Units.xroute',
            date: "Units.xroute.date",
            event: "Units.xroute.event",
            id: {
                main: 'Units.xroute.id',
                calculateRouteId: 'Units.xroute.calculateRouteId'
            },
        },
        video: {
            main: 'Units.video',
            live: 'Units.liveVideo',
            event: 'Units.video-event',
            request: 'Units.video-request',
        },
        type: {
            xtrack: {
                main: 'Units.xtrack',
                info: 'Units.xtrack.info',
                track: 'Units.xtrack.track',
                sensors: 'Units.xtrack.sensors',
                event: 'Units.xtrack.event',
                liveVideo: 'Units.xtrack.live-video',
                videoEvent: 'Units.xtrack.video-event',
                videoEventUnitTracking: 'Units.xtrack.video-event.unit-tracking',
                videoRequest: 'Units.xtrack.video-request',
                videoRequestUnitTracking: 'Units.xtrack.video-request.unit-tracking',
                date: 'Units.xtrack.date',
                sharedLinks: 'Units.xtrack.shared-links',
            },
            m2m: {
                main: 'Units.m2m',
                info: 'Units.m2m.info',
                track: 'Units.m2m.track',
                sensors: 'Units.m2m.sensors',
                event: 'Units.m2m.event',
                liveVideo: 'Units.m2m.live-video',
                videoEvent: 'Units.m2m.video-event',
                videoEventUnitTracking: 'Units.m2m.video-event.unit-tracking',
                videoRequest: 'Units.m2m.video-request',
                videoRequestUnitTracking: 'Units.m2m.video-request.unit-tracking',
                date: 'Units.m2m.date',
                sharedLinks: 'Units.m2m.shared-links',
            },
            m2m_chassis: {
                main: 'Units.m2m_chassis',
                info: 'Units.m2m_chassis.info',
                track: 'Units.m2m_chassis.track',
                sensors: 'Units.m2m_chassis.sensors',
                event: 'Units.m2m_chassis.event',
                liveVideo: 'Units.m2m_chassis.live-video',
                videoEvent: 'Units.m2m_chassis.video-event',
                videoEventUnitTracking: 'Units.m2m_chassis.video-event.unit-tracking',
                videoRequest: 'Units.m2m_chassis.video-request',
                videoRequestUnitTracking: 'Units.m2m_chassis.video-request.unit-tracking',
                date: 'Units.m2m_chassis.date',
                sharedLinks: 'Units.m2m_chassis.shared-links',
            },
            xvision: {
                main: 'Units.xvision',
                info: 'Units.xvision.info',
                track: 'Units.xvision.track',
                liveVideo: 'Units.xvision.live-video',
                event: 'Units.xvision.event',
                videoEvent: 'Units.xvision.video-event',
                videoEventUnitTracking: 'Units.xvision.video-event.unit-tracking',
                videoRequest: 'Units.xvision.video-request',
                videoRequestUnitTracking: 'Units.xvision.video-request.unit-tracking',
                sensors: 'Units.xvision.sensors',
                snapshots: 'Units.xvision.snapshots',
                date: 'Units.xvision.date',
                sharedLinks: 'Units.xvision.shared-links',
            },
            pro_cargo_vision: {
                main: 'Units.proCargoVision',
                info: 'Units.proCargoVision.info',
                track: 'Units.proCargoVision.track',
                liveVideo: 'Units.proCargoVision.live-video',
                event: 'Units.proCargoVision.event',
                map: 'Units.proCargoVision.map',
                mapEvent: 'Units.proCargoVision.mapEvent',
                videoEvent: 'Units.proCargoVision.video-event',
                videoEventUnitTracking: 'Units.proCargoVision.video-event.unit-tracking',
                videoRequest: 'Units.proCargoVision.video-request',
                videoRequestUnitTracking: 'Units.proCargoVision.video-request.unit-tracking',
                screenshotsEvent: 'Units.proCargoVision.screenshots',
                screenshotsEventUnitTracking: 'Units.proCargoVision.screenshots.unit-tracking',
                sensors: 'Units.proCargoVision.sensors',
                snapshots: 'Units.proCargoVision.snapshots',
                date: 'Units.proCargoVision.date',
                sharedLinks: 'Units.proCargoVision.shared-links',
                smartSearch: {
                    main: 'Units.proCargoVision.smartSearch',
                    videoRequest: 'Units.proCargoVision.smartSearch.video-request'
                },
            },
            xbles: {
                main: 'Units.xbles',
                info: 'Units.xbles.info',
                event: 'Units.xbles.event',
                date: 'Units.xbles.date',
                sharedLinks: 'Units.xbles.shared-links',
                map_info: {
                    main: "Units.xbles.mapInfo",
                    id: "Units.xbles.mapInfo.id",
                },
                id: {
                    main: 'Units.xbles.id',
                },
                //track: 'Units.xbles.track',
                //sensors: 'Units.xbles.sensors',
            },
            obd: {
                main: 'Units.OBD',
                info: 'Units.OBD.info',
                tags: 'Units.OBD.tags',
                fastGeozone: 'Units.OBD.fastGeozone',
                map: 'Units.OBD.map',
                event: 'Units.OBD.event',
                liveVideo: 'Units.OBD.live-video',
                videoEvent: 'Units.OBD.video-event',
                videoEventUnitTracking: 'Units.OBD.video-event.unit-tracking',
                videoRequest: 'Units.OBD.video-request',
                videoRequestUnitTracking: 'Units.OBD.video-request.unit-tracking',
                track: 'Units.OBD.track',
                date: 'Units.OBD.date',
                sharedLinks: 'Units.OBD.shared-links',
                visionMD: {
                    main: 'Units.OBD.visionMD'
                }
            },
            xcool: {
                main: 'Units.xcool',
                info: 'Units.xcool.info',
                track: 'Units.xcool.track',
                sensors: 'Units.xcool.sensors',
                event: 'Units.xcool.event',
                setPoint: 'Units.xcool.setPoint',
                setPointTemplate: 'Units.xcool.setPointTemplate',
                startDefrost: 'Units.xcool.startDefrost',
                startPti: 'Units.xcool.startPti',
                date: 'Units.xcool.date',
                sharedLinks: 'Units.xcool.shared-links',
                alarms: {
                    main: 'Units.xcool.alarms',
                    xid: 'Units.xcool.alarms.xid',
                },
                greenSee: {
                    main: 'Units.xcool.greenSee'
                },
                analytics: 'Units.xcool.analytics',
                history: 'Units.xcool.history',
                diagnostics: 'Units.xcool.diagnostics',
                greensee: 'Units.xcool.greensee',
            },
            sensors: {
                main: 'Units.sensors',
                info: 'Units.sensors.info',
                map: 'Units.sensors.map',
                track: 'Units.sensors.track',
                date: 'Units.sensors.date',
                event: 'Units.sensors.event',
                liveVideo: 'Units.sensors.live-video',
                videoEvent: 'Units.sensors.video-event',
                videoEventUnitTracking: 'Units.sensors.video-event.unit-tracking',
                videoRequest: 'Units.sensors.video-request',
                videoRequestUnitTracking: 'Units.sensors.video-request.unit-tracking',
            },
        },
        smartSearch: {
            main: 'Units.smartSearch',
            date: 'Units.smartSearch.date',
            time: {
                main: 'Units.smartSearch.time',
                videoRequest: 'Units.smartSearch.time.videoRequest',
                accidentView: 'Units.smartSearch.time.accidentView',
            },
            geozone: {
                main: 'Units.smartSearch.geozone',
                videoRequest: 'Units.smartSearch.geozone.videoRequest',
            },
            videoRequest: 'Units.xvision.smartSearch.video-request'
        },
        timeCapsule: {
            main: 'Units.timeCapsule',
            template: {
                xvision: {
                    main: 'Units.timeCapsule.xvision',
                    date: 'Units.timeCapsule.xvision.date',
                    video: 'Units.timeCapsule.xvision.video',
                },
            },
        },
        playback: {
            main: 'Units.playback',
            template: {
                xvision: {
                    main: 'Units.playback.xvision',
                    date: 'Units.playback.xvision.date',
                },
            },
        },
        track: {
            main: "Units.track",
            xid: "Units.track.xid",
            event_xid: "Units.track.event.xid",
            video: {
                event: 'Units.track.xid.video-event',
                request: 'Units.track.xid.video-request',
            },
            asset: {
                main: 'Tracks.unit.asset',
                index: 'Tracks.unit.asset.index'
            },
        }
    },
    units_groups: {
        main: 'UnitsGroups',
        groups: {
            main: 'UnitsGroups.groups',
            geozone: 'UnitsGroups.groups.geozone',
            unitId: 'UnitsGroups.groups.unitId',
        },
        geozones: 'UnitsGroups.geozones',
        id: 'UnitsGroups.id',
        map: 'UnitsGroups.map',
        edit: 'UnitsGroups.edit'
    },
    services: {
        main: 'Services',
        id: 'Services.id',
        list: 'Services.list',
        service: 'Services.service'
    },
    tracks: {
        main: 'Tracks',
        lite: 'Tracks.lightView',
        date: 'Tracks.date',
        unit: {
            main: 'Tracks.unit',
            asset: {
                main: 'Tracks.unit.asset',
                index: 'Tracks.unit.asset.index'
            },
        },
        xid: 'Tracks.xid',
        event_xid: 'Tracks.event-xid',
        move_on_track: 'Tracks.moveOnTrack',
        video: {
            event: 'Tracks.video-event',
            request: 'Tracks.video-request',
        }
    },
    notificationsevents: {
        main: 'NotificationsEvents',
        lite: 'NotificationsEvents.lightView',
        date: 'NotificationsEvents.date',
        filter: 'NotificationsEvents.filter',
        edit: {
            main: 'NotificationsEvents.edit',
        },
        popup: {
            main: 'NotificationsEvents.popup',
        }
    },
    geoitems: {
        main: 'Geoitems',
        geozones: {
            main: 'Geoitems.geozones',
            group: {
                id: 'Geoitems.geozones.group.id',
                edit: 'Geoitems.geozones.group.edit',
                geozoneId: 'Geoitems.geozones.group.geozoneId',
                geozoneEdit: 'Geoitems.geozones.group.geozoneEdit',
            }
        },
        id: 'Geoitems.id',
        lite: 'Geoitems.lightView',
        edit: {
            main: 'Geoitems.edit',
            editPopup: 'Geoitems.geozones.edit.popup',
        },
        groups: {
            main: 'Geoitems.group',
            edit: {
                main: 'Geoitems.group.edit'
            }
        },
    },
    object_changes: {
        main: 'ObjectsChanges',
    },
    recycle_bin: {
        main: 'RecycleBin',
        restore: 'RecycleBin.restore',
        edit: {
            unit: 'RecycleBin.unit-edit',
        },
        history: {
            unit: 'RecycleBin.unit-history',
            user: 'RecycleBin.user-history',
        }
    },
    statistics: {
        main: 'Statistics',
        statement: 'Statistics.statement',
        mileage: 'Statistics.mileage',
    },
    analytics: {
        main: 'analytics'
    },
    routes: {
        main: 'Routes',
    },
    locator: {
        main: 'Locator',
    },
    alarms: {
        main: 'Alarms',
    },
    dashboard_gauges: {
        main: 'DashboardGauges',
    },
    fuel: {
        main: 'Fuel',
    },
    fuel_cards: {
        main: 'FuelCards',
    },
    drivers: {
        main: 'Drivers',
        id: 'Drivers.id',
        scorecard: 'Drivers.ScoreCard',
        edit: {
            main: 'Drivers.edit',
            group: 'Drivers.groupEdit',
            create: 'Drivers.create',
        },
    },
    maintenance: {
        main: 'Maintenance',
        vendors: 'Maintenance.vendors',
        vendors_id: 'Maintenance.vendors.id',
        vendors_edit: 'Maintenance.vendors.edit',
        work_order: 'Maintenance.work-order',
        work_order_id: 'Maintenance.work-order.id',
        work_order_edit: 'Maintenance.work-order.edit',
        issues: 'Maintenance.issues',
        issues_id: 'Maintenance.issues.id',
        issues_edit: 'Maintenance.issues.edit',
        service_tasks: 'Maintenance.service-tasks',
        service_tasks_id: 'Maintenance.service-tasks.id',
        service_tasks_edit: 'Maintenance.service-tasks.edit',
        parts: 'Maintenance.parts',
        parts_id: 'Maintenance.parts.id',
        parts_edit: 'Maintenance.parts.edit',
        contacts: 'Maintenance.contacts',
        contacts_id: 'Maintenance.contacts.id',
        contacts_edit: 'Maintenance.contacts.edit',
        contacts_group: 'Maintenance.contacts-group.edit',
        contacts_group_id: 'Maintenance.contacts-group.id',
        contacts_group_edit: 'Maintenance.contacts-group.edit',
        inspections: 'Maintenance.inspections',
        inspections_id: 'Maintenance.inspections.id',
        inspections_edit: 'Maintenance.inspections.edit',
        history: 'Maintenance.history',
        history_id: 'Maintenance.history.id',
        history_create: 'Maintenance.history.create',
        history_edit: 'Maintenance.history.edit',
        history_create_add_service_task: 'Maintenance.history.create.add.service-task',
        history_edit_add_service_task: 'Maintenance.history.edit.add.service-task',
        expenses: 'Maintenance.expenses',
        expenses_id: 'Maintenance.expenses.id',
        expenses_edit: 'Maintenance.expenses.edit',
    },
    personnel: {
        main: 'Personnel',
    },
    reports: {
        main: 'Reports',
        template: 'Reports.template',
        system: 'Reports.system',
        mongo: 'Reports.mongo',
        jobManager: {
            main: 'Reports.jobManager',
            edit: 'Reports.jobManager.edit',
        },
    },
    video: {
        main: 'Video',
    },
    passengers: {
        main: '',//toDo route name
    },
    shipments_locator: {
        main: 'ShipmentsLocator',
        info: 'ShipmentsLocator.info',
    },
}
const consts = {
    testSites: {
        portal: 'portal.prometheuspro.dev',
        admin: 'admin.prometheuspro.dev',
        legacy: 'test.prometheuspro.us'
    },
    timeoutReadyComponent: 300,
    querySettings: {
        filter: {'filter[changed]': 600},
        pageSize: 500,
        // unitsPageSize: 100,
        maxPages: 8,
        maintenance: {
            pageSize: 1000
        }
    },
    routerNames,
    customServices: [
        {id: 'maintenance', name: 'Maintenance'},
        //{id: 'fuel_cards', name: 'Fuel cards'},
        //{id: 'driver_score_cards', name: 'Driver score cards'},
    ],
    userProfile: {
        permissions: {
            default: [
                //'companies',
                'users',
                //'users_groups',
                'units',
                'units_groups',
                'geoitems',
                //'drivers',
                //'drivers_groups',
                'appointment',
                'accidents',
                'insurance',
                'video_requests',
                'notifications',
            ],
            maintenance: [
                'maintenance',
                'maintenance_work_order',
                'maintenance_issues',
                'maintenance_inspections',
                'maintenance_history',
                'maintenance_service_tasks',
                'maintenance_parts',
                'maintenance_vendors',
                'maintenance_contacts',
                'maintenance_contacts_groups',
                'maintenance_notifications',
                'maintenance_expenses',
            ]
        }
    },
    locatorTimeout: [
        {id: 'hours', name: 'Hours', sort: 1},
        {id: 'days', name: 'Days', sort: 2},
        {id: 'weeks', name: 'Weeks', sort: 3},
        {id: 'months', name: 'Months', sort: 4},
    ],
    customizeColorThemes: [
        {id: 'blue',   name: 'Blue' },
        {id: 'darkblue',   name: 'Dark Blue' },
        {id: 'orange', name: 'Orange' },
        {id: 'gray',  name: 'Gray' },
    ],
    LiveVideo: {
        slideshow:{
            default: 1,//sec
            error: 10,//sec
        },
        timeout: 60,//sec
        unitsIdsTimeout3min: [26570, 26579, 26581, 26582, 26583]
    },
    usersObjectsTemplatesIcons: {
        reefer: [
            {id: 'alcoholic_drinks_bottle', name: 'Alcoholic Drinks Bottle'},
            {id: 'biochemical', name: 'Biochemical'},
            {id: 'bread', name: 'Bread'},
            {id: 'butter', name: 'Butter'},
            {id: 'cakes', name: 'Cakes'},
            {id: 'cheese', name: 'Cheese'},
            {id: 'chocolates', name: 'Chocolates'},
            {id: 'cookies', name: 'Cookies'},
            {id: 'eggs', name: 'Eggs'},
            {id: 'flowers', name: 'Flowers'},
            {id: 'fruits', name: 'Fruits'},
            {id: 'ice-cream', name: 'Ice Cream'},
            {id: 'meat', name: 'Meat'},
            {id: 'medicines', name: 'Medicines'},
            {id: 'milk', name: 'Milk'},
            {id: 'non-alcoholic', name: 'Non Alcoholic'},
            {id: 'other', name: 'Other'},
            {id: 'reefer_fish', name: 'Fish'},
            {id: 'tropical-plants', name: 'Tropical Plants'},
            {id: 'vaccines', name: 'Vaccines'},
            {id: 'vegetables', name: 'Vegetables'},
            {id: 'yogurt', name: 'Yogurt'},
        ]
    },
    templates: {
        unitLite: {
            routeName: routerNames.units.lite,
            extensions: {
                byUnitHwType: ['xpower'],// xlink - ???
            },
        },
        // tracksLite: {
        //     routeName: routerNames.tracks.lite,
        //     extensions: {},
        // },
        // geoitemsLite: {
        //     routeName: routerNames.geoitems.lite,
        //     extensions: {},
        // },
        // notificationseventsLite: {
        //     routeName: routerNames.notificationsevents.lite,
        //     extensions: {},
        // }
    },
    shortWidth: 690,
    typesForTrackByPoints: ['reefer_trailer', 'dry_trailer', 'chassis'],
    map: {
        center: [25.761681, -80.191788],
    },
    dealer_shop: 'https://83fbbd-2.myshopify.com/',
    shopify: {
        dealer: {
            domain: '83fbbd-2.myshopify.com',
            storefrontAccessToken: '97f09cc3f6cdb53725424cffe62d69ff'
        },
        client: {
            domain: '83fbbd-2.myshopify.com',
            storefrontAccessToken: '97f09cc3f6cdb53725424cffe62d69ff'
        },
    },
    units_of_measure: ['imperial', 'metric'],
    customizeDomains: [
        {id: 'portal',        label: 'Portal',        disabled: false, disabled_SuperAdmin: false},
        {id: 'portal_legacy', label: 'Portal legacy', disabled: false, disabled_SuperAdmin: false},
        {id: 'admin',         label: 'Admin',         disabled: false, disabled_SuperAdmin: false},
        {id: 'hw',            label: 'HW',            disabled: true, disabled_SuperAdmin: false},
    ],
    entri: {
        add_domains: [
            {id: 'portal', label: 'Portal', def_value: 'portal'},
            {id: 'portal_legacy', label: 'Portal legacy', def_value: 'tracking'},
            {id: 'admin', label: 'Admin', def_value: 'proadmin'},
            {id: 'hw', label: 'HW', def_value: 'hw'},
        ]
    },
    recyclebin_time_left: 60 * 24 * 3600,
    menus: {
        portal: [
            {id: "orchestrator",    name: routerNames.orchestrator.main,    title: 'ORC', icon: "menu__orchestrator", hide_menu_enable: true},
            {id: "md",              name: routerNames.md.main,              title: ("menu.MD"), icon: "menu__md", hide_menu_enable: true},
            {id: "units",           name: routerNames.units.main,           title: ("menu.Units"), icon: "menu__car"/*icon: "menu__car"*/, hide_menu_enable: true},
            {id: "units-groups",    name: routerNames.units_groups?.main,   title: ("menu.Groups"), icon: "menu__units-groups", hide_menu_enable: true},
            {id: "geoitems",        name: routerNames.geoitems.main,        title: ("menu.Geoitems"), icon: "menu__geoitems", hide_menu_enable: true},
            {id: "reports",         name: routerNames.reports.main,         title: ("menu.Reports"), icon: "menu__reports", hide_menu_enable: true},
            {id: "services",        name: routerNames.services.main,        title: ("menu.ProHUB"), icon: "menu__proHub2", hide_menu_enable: true},
            {id: "drivers",         name: routerNames.drivers.main,         title: ("menu.Drivers"), icon: "menu__driver"},
            {id: "help",            name: routerNames.help.main,            title: ('menu.Help'),    icon: "menu__help", hide_menu_enable: true},
            // {id: "tracks",          name: ''/*name: routerNames.tracks.main*/,         title: ("menu.Tracks"), icon: "menu__tracks"},
            // {id: "notifications",   name: ''/*name: routerNames.notificationsevents.main*/,  title: ("menu.Notice"), icon: "menu__notifications"},
            // {id: "routes",          name: ''/*name: routerNames.routes.main*/,         title: ("menu.Routes"), icon: "menu__routes"},
            // {id: "personnel",       name: ''/*name: routerNames.personnel.main*/,      title: ("menu.Personnel"), icon: "menu__personnel"},
            // {id: "passengers",      name: ''/*name: routerNames.passengers.main*/,     title: ("menu.Passengers"), icon: "menu__passengers"},
            // {id: "fuel",            name: ''/*name: routerNames.fuel.main*/,           title: ("menu.Fuel"), icon: "menu__fuel"},
            // {id: "maintenance",     name: ''/*name: routerNames.maintenance.main*/,    title: ("menu.Maintenance"), icon: "menu__maintenance"},
            // {id: "alarms",          name: ''/*name: routerNames.alarms.main*/,         title: ("menu.Alarms"), icon: "menu__alarm"},
            // {id: "video",           name: ''/*name: routerNames.video.main*/,          title: ("menu.Video"), icon: "menu__video"},
            // {id: "fuel_cards",      name: ''/*name: routerNames.fuel_cards.main*/,     title: ("menu.Fuel cards"), icon: "menu__fuel_cards"},
            // {id: "gauges",          name: ''/*name: routerNames.dashboard_gauges.main*/, title: ("menu.Gauges"), icon: "menu__gauges"},
            //
            // {id: "help",            name: ''/*name: routerNames.help.main*/,           title: ('menu.Help'), icon: "menu__help"},
            // {id: "test",         name: routerNames.test.main,           title: ('menu.TestPage'), icon: "menu__test"},
        ],
        admin: [
            // {id: "statistics", name: routerNames.statistics.main, title: ('menu.Dashboard'), icon: "menu__dashboard"},
            {id: "users-profiles", name: routerNames.usersProfiles.main, title: ("menu.Users Profiles"), icon: "menu__user-profile"},
            {id: "users", name: routerNames.users.main, title: ("menu.Users"), icon: "menu__personnel"},
            {id: "units", name: routerNames.units.main, title: ("menu.Units"), icon: "menu__car"},
            {id: "recycle-bin", name: routerNames.recycle_bin.main, title: ("menu.Recycle Bin"), icon: "menu__delete"},
            // {id: "user-actions", name: routerNames.users.actions.main, title: ("menu.User actions"), icon: "menu__history"},
            // {id: "objs-changes", name: routerNames.object_changes.main, title: ("menu.Objs changes"), icon: "menu__history"},
            // {id: "dealer",          name: routerNames.dealer.main,         title: ('menu.Dealer'), icon: "menu__dealer"},
            // {id: "help",            name: routerNames.help.main,           title: ('menu.Help'), icon: "menu__help"},
            // {id: "test",            name: routerNames.test.main,           title: ('menu.TestPage'), icon: "menu__test"},
        ],
        geotab: [
            {id: "md",              name: routerNames.md.main,             title: ("menu.MD"), icon: "menu__md"},
            {id: "units",           name: routerNames.units.main,          title: ("menu.Units"), icon: "menu__car"},
        ],
        mainSize: 9,
    },
    FilterSearchLists: {
        Units: {
            signals: [
                {id: 'on', name: ('ON line'), translate: ('Units.signals.ON line'), icon: 'common__car'},
                {id: 'off', name: ('OFF line'), translate: ('Units.signals.OFF line'), icon: 'common__car'},
            ],
            movements: [
                {id: 'moving', name: ('Moving'), translate: ('Units.movements.Moving'), icon: 'common__car'},
                {id: 'stopped', name: ('Stopped'), translate: ('Units.movements.Stopped'), icon: 'common__car'},
                {id: 'ignition', name: ('Ignition on'), translate: ('Units.movements.Ignition on'), icon: 'common__car'},
            ],
            car_icons: [
                {id: 'map__car_type_sedan', name: ('Sedan'), translate: ('Units.icons.Sedan'), group:'Dynamic', isColored: true},
                {id: 'map__car_type_pickup', name: ('Pickup'), translate: ('Units.icons.Pickup'), group:'Dynamic', isColored: true},
                {id: 'map__car_type_truck', name: ('Truck'), translate: ('Units.icons.Truck'), group:'Dynamic', isColored: true},
                {id: 'map__car_type_motorbike', name: ('Motorbike'), translate: ('Units.icons.Motorbike'), group:'Dynamic', isColored: true},
                {id: 'map__car_type_taxi', name: ('Taxi'), translate: ('Units.icons.Taxi'), group:'Static', isColored: false},
                {id: 'map__car_type_police', name: ('Police'), translate: ('Units.icons.Police'), group:'Static', isColored: false},
                {id: 'map__car_type_ambulance', name: ('Ambulance'), translate: ('Units.icons.Ambulance'), group:'Static', isColored: false},
            ],
            camera: [
                {id: 'all', name: 'All Cameras', translate: 'Units.camera.All Cameras', icon: 'camera-online', color: 'gray'},
                {id: 'online', name: 'Cameras Online', translate: 'Units.camera.Cameras Online', icon: 'camera-online', color: '#0ec900'},
                {id: 'offline', name: 'Cameras Offline', translate: 'Units.camera.Cameras Offline', icon: 'camera-offline', color: 'red'},
            ],
        },
        Events: {
            types: [
                {id: 'lost connection', type: 'event', name: ('Lost connection'), translate: ('Events.types.Lost connection'), icon: 'notifications__lost-connection'},
                {id: 'low battery', type: 'event', name: ('Low battery'), translate: ('Events.types.Low battery'), icon: 'notifications__low-battery'},
                {id: 'max speed', type: 'event', name: ('Max speed'), translate: ('Events.types.Max speed'), icon: 'notifications__max-speed'},
                {id: 'input', type: 'event', name: ('Input alert'), translate: ('Events.types.Input alert'), icon: 'notifications__input'},
            ],
        },
        NotificationsEvents: {
            types: [
                // {id: '1', type: 'notification-event', name: ('Parameters control'), translate: ('NotifEvents.types.Parameters control'), icon: 'notifications__parameter_control'},
                {id: '2', type: 'notification-event', name: ('Entry into geosite'), translate: ('NotifEvents.types.Entry into geosite'), icon: 'notifications__geozone_entrance_control'},
                {id: '3', type: 'notification-event', name: ('Exit from geosite'), translate: ('NotifEvents.types.Exit from geosite'), icon: 'notifications__geozone_exit_control'},
                // {id: '4', type: 'notification-event', name: ('Approaching geopoint'), translate: ('NotifEvents.types.Approaching geopoint'), icon: 'notifications__approaching_geopoint'},
                // {id: '5', type: 'notification-event', name: ('Distance geopoint'), translate: ('NotifEvents.types.Distance geopoint'), icon: 'notifications__distance_geopoint'},
                // {id: '6', type: 'notification-event', name: ('Lost connection'), translate: ('NotifEvents.types.Lost connection'), icon: 'notifications__lost-connection'},
                // {id: '7', type: 'notification-event', name: ('Sensors control'), translate: ('NotifEvents.types.Sensors control'), icon: 'notifications__sensor_control'},
                // {id: '9', type: 'notification-event', name: ('Approaching object'), translate: ('NotifEvents.types.Approaching object'), icon: 'notifications__approaching_object'},
                // {id: '10', type: 'notification-event', name: ('Overspeeding by GIS'), translate: ('NotifEvents.types.Overspeeding by GIS'), icon: 'notifications__overspeeding_gis'},
                // {id: '11', type: 'notification-event', name: ('Maintenance'), translate: ('NotifEvents.types.Maintenance'), icon: 'notifications__maintenance'},
                // {id: '12', type: 'notification-event', name: ('Fuel control'), translate: ('NotifEvents.types.Fuel control'), icon: 'notifications__fuel_control'},
                // {id: '17', type: 'notification-event', name: ('Towing'), translate: ('NotifEvents.types.Towing'), icon: 'notifications__towing'},

                //{id: '8', type: 'notification-event', name: ('Track control'), translate: ('NotifEvents.types.Track control'), icon: 'notifications__'},
                //{id: '14', type: 'notification-event', name: ('Condition control'), translate: ('NotifEvents.types.Condition control'), icon: 'notifications__condition_control'},//???
                //{id: '14', type: 'notification-event', name: ('Condition control'), translate: ('NotifEvents.types.Condition control'), icon: 'notifications__movement'},
                //{id: '14', type: 'notification-event', name: ('Condition control'), translate: ('NotifEvents.types.Condition control'), icon: 'notifications__parking'},
                //'attribute' => 'type_condition', 'images' => ['movement' => 'movement','parking' => 'parking',],

                //{id: '15', type: 'notification-event', name: ('Control of presence inside of geozone'), translate: ('NotifEvents.types.Control of presence inside of geozone'), icon: 'notifications__'},
                //{id: '16', type: 'notification-event', name: ('Control of absence inside of geozone'), translate: ('NotifEvents.types.Control of absence inside of geozone'), icon: 'notifications__'},

            ],
        },
        VideoEvents: {
            types: [
                {id: 'video-event', type: 'video-event', name: ('Video event'), translate: ('VideoEvents.types.Video event'), icon: 'notifications__video-event'},
                // {id: 'ADAS', type: 'video-event', name: ('ADAS Video event'), translate: ('VideoEvents.types.ADAS Video event'), icon: 'notifications__video-event'},
                // {id: 'other', type: 'video-event', name: ('Other Video event'), translate: ('VideoEvents.types.other Video event'), icon: 'notifications__video-event'},
            ],
        }
    },
    ReeferTypes: [
        {
            'title': '-',
            'type':  '',
        },
        {
            'title': 'Thermo King',
            'type':  'thermo_king',
            'icon': 'reefer__king',
        },
        {
            'title': 'Carrier',
            'type':  'carrier',
            'icon': 'reefer__carrier',
        },
    ],
    costMode: [
        // {value: 'units', title: 'Ежемесячная абонентская плата по активным объектам'},
        {value: 'units_all', title: 'Monthly fee for all objects'},
        // {value: 'days', title: 'Cписывать дни'},
        // {value: 'units_days', title: 'Ежедневный платеж по активным объектам'},
        {value: 'units_days_all', title: 'Daily fee for all units'},
    ],
    unitsOfMeasures: {
        'distanceUnits': "km",
        'speedUnits': "kph",
        'altitudeUnits': "m",
        'volumeUnits': "l",
        // 'fuelEconomyUnits': "lPer100km",
        'temperatureUnits': "C",
        'lightingUnits': "Lx",
        'humidityUnits': "%",
        // 'pressureUnits': "pa",
        // 'pressedUnits': "mbar",
        // 'precipUnits': "mm",
        // 'percentageUnits': "%",
        // 'electricalUnits': "V",
        // 'timeUnits': "s",
    },
    Licenses: {
        params: [
            {days: 30, text: '1 month', color: '#FE6D23'},
            {days: 90, text: '3 months', color: '#FFB700'},
            {days: 180, text: '6 months', color: '#90C20B'},
            {days: 365, text: '1 year', color: '#01CB25'},
        ],
    },
    uploadError: {
        "invalidFileExtension": "Invalid file extension",
        "invalidMaxFileSize": "Invalid max file size",
        "invalidMixFileSize": "Invalid min file size"
    },
    unitsList: {
        useTypeForTemplate: ['ble_gateway', 'ble_tag', 'xtag'],
    },
    viewMACAddressByUnit: {
        type: ['ble_gateway', 'ble_tag'],
        hw_type: ['xtag', 'xlink'],
    },
    unitsGroupsColors: [
        '#C2E0FB', '#8CDBAC', '#DDEB87', '#F5E594', '#E1D9F7', '#9898FF', '#FF9898',
        '#FFB957', '#CECECE', '#52EBFF', '#FF80D5', '#B1FBE0', '#D6AB77', '#99B0B6',
        '#C7B6DD', '#DA9DC9', '#FFC699', '#FFFAEA', '#FDC5CE', '#9DACC9', '#F77F62',
        '#F1A351', '#B1B084', '#AF78F0', '#D199FF', '#FF585C', '#FF7477', '#F2FF0D',
        '#FBFFAE', '#A6FF0D', '#7EFFA2', '#05B0FF', '#DF52FF', '#C6D101', '#FF4E8F',
        '#FFFFFF', '#93B2FF', '#35FFC6', '#CEAF00',
    ],
    statusesObjects: [
        {id: 'moving',        color: '#2FC76B',  title: 'In Motion', class: 'status-unit-moving', z_index: 3},
        {id: 'driving',        color: '#2FC76B',  title: 'In Motion', class: 'status-unit-moving', z_index: 3},
        {id: 'driving-asset',  color: '#2FC76B',  title: 'Points', class: 'status-unit-moving'},
        {id: 'parked',        color: '#0276F0',  title: 'Parked', class: 'status-unit-parked'},
        {id: 'parking',        color: '#0276F0',  title: 'Parked', class: 'status-unit-parked'},
        {id: 'idling',        color: '#FD3939',  title: 'Idling', class: 'status-unit-idling', z_index: 2},
        {id: 'offline',       color: '#ff0000',  title: 'Offline', class: 'status-unit-offline'},
        {id: 'not_connection',color: '#000000',  title: 'Not connection', class: 'status-unit-not_connection'},
        {id: 'standBy',        color: '#FF8B1C',  title: 'Standby', class: 'status-unit-stand-by', z_index: 1},
        {id: 'video-records',  color: '#2FC76B',  title: 'Video Records', class: 'status-unit-video-records', z_index: 1},
        {id: 'alerts',        color: '#ff0000',  title: 'Alerts', class: 'status-shipment-alert', z_index: 3},
        {id: 'loaded',        color: '#5FDC00',  title: 'Loaded', class: 'status-unit-stand-loaded', z_index: 1},
        {id: 'unloaded',        color: '#A0A0A0',  title: 'Unloaded', class: 'status-unit-stand-unloaded', z_index: 1},
        {id: 'report',        color: '#ff0000',  title: 'Claim process', class: 'status-unit-report', z_index: 4},
        {id: 'startEndInterval', color: '#2FC76B',  title: 'Interval', class: 'status-unit-interval', z_index: 4},
        {id: 'group-by-sensor_alarms', color: '#ff0000',  title: 'Alerts', class: 'status-unit-alert', z_index: 4},
        {id: 'group-by-sensor_power', color: '#10E4EB',  title: 'Running', class: 'status-unit-power', z_index: 4},
        {id: 'recovery-mode',  color: '#ff0000',  title: 'Recovery Mode', class: 'status-unit-recovery-mode', z_index: 4},
        {id: 'group-by-is_motion', color: '#FF8B1C',  title: 'Run Time', class: 'status-unit-is_motion', z_index: 4},
        {id: 'screenshots-interval', color: '#A0A0A0',  title: 'Screenshots', class: 'status-unit-screenshots-interval', z_index: 4, showValue: true},
        {id: 'smart-search-geozone', color: '#ffa1a1',  title: 'Geozone', class: 'status-unit-smart-search-geozone', z_index: 4},
    ],
    videoFormats: [
        {id: 'mp4',    name: 'mp4'},
        {id: 'images', name: 'images'},
    ],
    timeline: {
        eventpoint_width_px: 10,
        eventsgroup__width_px: 24+16,
        startsEnd__width_px: 24,
        movePointWidth: 2,//20
        groupingTime: 3600 / 2,
        requestTimeFormat: 'HH:mm:ss',
        datetime_error: 'Current time is out of available time frame, video can\'t be requested',
        requestSeconds: [
            {id: 1, name: '0'},
            {id: 10, name: '10'},
            {id: 20, name: '20'},
            {id: 30, name: '30'},
            {id: 40, name: '40'},
            {id: 60, name: '60'},
            {id: 120, name: '120'},
        ],
    },
    timelineFilter: [
        {id: 'event', name: 'Events'},
        {id: 'command', name: 'Commands'},
        {id: 'video-event', name: 'Video events'},
        {id: 'notification-event', name: 'Notifications events'},
        {id: 'video-request', name: 'Video requests', video: true},
    ],
    screenshots: {
        types: {
            time_caps: ['time_caps'],
        }
    }
}
export default consts